<div class="text-center">
  <h1>CREDENCIALES ACTIVE DIRECTORY</h1>
  <p>
    Debe ingresar usuario y clave del usuario administrador del Active
    Directory.
  </p>
  <form [formGroup]="form">
    <mat-form-field>
      <input
        matInput
        type="text"
        formControlName="usuario"
        placeholder="Ingrese el Usuario"
      />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="password"
        formControlName="clave"
        placeholder="Ingrese la Contraseña"
      />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="text"
        formControlName="url"
        placeholder="URL (LDAP://SQLSERVER.gruposip.com)"
      />
    </mat-form-field>
    <mat-form-field>
      <input
        matInput
        type="text"
        formControlName="baseDN"
        placeholder="BaseDN (dc=gruposip,dc=com)"
      />
    </mat-form-field>
  </form>
  <button class="btn btn-primary" (click)="save()">Actualizar</button>
  <button class="btn btn-secondary" mat-dialog-close style="margin-left: 10px">
    Cerrar
  </button>
</div>
